module.exports = __webpack_public_path__ + "media/images/pages-7cedfefb33c4f17a9f7f9919a72f6fe3.svg";